import { Outlet } from "react-router-dom";
import "./LandingLayout.scss";
import { Box } from "@chakra-ui/react";
import { IBodyshopService } from "../../UserService";
import { CommonMethodService } from "../../Services/CommonMethodService";
import { useEffect, useState } from "react";
const LandingLayout = () => {
  const commonMethodService = new CommonMethodService();
  const [estimateData, setEstimateData] = useState<any>(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [headerText, setHeaderText] = useState<string | null>(null)

  useEffect(() => {
    setIsAdmin(commonMethodService.getDataFromStorage("isAdmin"));
    setEstimateData(commonMethodService.getDataFromStorage("estimateData"));
  }, []);

  useEffect(()=>{
    setHeaderText(commonMethodService.getAdminHeaderText(estimateData, true))
  },[estimateData])


  return (
    <>
    {
      (isAdmin && headerText) &&
      <Box bg="blue.800" className="text-center">
            <div className="py-3">
              <h1 className={"ellipsis text-white font-medium text-xl"}>{`${headerText}`}</h1>
            </div>
      </Box>
    }
      <div className="layout-main">
        <div className="layout-container">
          <Outlet />
        </div>
      </div>
    </>
  );
};

export default LandingLayout;
